import React from 'react';
import { Table } from 'semantic-ui-react';
import { states } from '@/constants/lifecycle';
import TableWrapper from '@/components/table/TableWrapper';
import CompactTableHeader from '@/components/table/CompactTableHeader';
import TableErrorRow from '@/components/table/TableErrorRow';
import CollectionDatasetsAssignTableRows from './CollectionDatasetsAssignTableRows';

const CollectionDatasetsAssignTable = ({
  category,
  code,
  readStatus,
  datasets,
  removeDataset,
  error,
  onErrorDismiss,
  children,
}) => (
  <TableWrapper className="aridhia-collection-datasets-assign-table" sticky>
    <Table.Header fullWidth>
      <CompactTableHeader
        isLoading={readStatus === states.PENDING}
        numberOfColumns={4}
        className="aridhia-collection-datasets-add-header"
        headerId="collection.datasets"
      />
      <TableErrorRow
        error={error}
        onErrorDismiss={onErrorDismiss}
        numberOfColumns={4}
      />
      { children }
    </Table.Header>
    <Table.Body>
      <CollectionDatasetsAssignTableRows
        category={category}
        code={code}
        items={datasets}
        readStatus={readStatus}
        removeDataset={removeDataset}
      />
    </Table.Body>
  </TableWrapper>
);

export default CollectionDatasetsAssignTable;
